import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TaskData {
    id?: number | null;
    type_id?: number;
    start_at?: string;
    end_at?: string;
    is_done?: boolean;
    comment?: string;
    user?: any;
    contact?: any;
    [key: string]: any;
}

interface TasksState {
    todayTasks: TaskData[];
    loaded: boolean;
    initialLoading: boolean;
}

const initialState: TasksState = {
    todayTasks: [],
    loaded: false,
    initialLoading: true,
};

const tasksSlice = createSlice({
    name: "tasks",
    initialState,
    reducers: {
        setTodayTasks(state, action: PayloadAction<TaskData[]>) {
            state.todayTasks = action.payload;
        },
        addTodayTask(state, action: PayloadAction<TaskData>) {
            const existingIndex = state.todayTasks.findIndex((t) => t.id === action.payload.id);
            if (existingIndex >= 0) {
                state.todayTasks[existingIndex] = action.payload;
            } else {
                state.todayTasks.push(action.payload);
            }
        },
        updateTodayTask(state, action: PayloadAction<{ id: number; updates: Partial<TaskData> }>) {
            const task = state.todayTasks.find((t) => t.id === action.payload.id);
            if (task) {
                Object.assign(task, action.payload.updates);
            }
        },
        removeTodayTask(state, action: PayloadAction<number>) {
            state.todayTasks = state.todayTasks.filter((t) => t.id !== action.payload);
        },
        setLoaded(state, action: PayloadAction<boolean>) {
            state.loaded = action.payload;
        },
        setInitialLoading(state, action: PayloadAction<boolean>) {
            state.initialLoading = action.payload;
        },
        clearTodayTasks(state) {
            state.todayTasks = [];
            state.loaded = false;
            state.initialLoading = true;
        },
    },
});

export const {
    setTodayTasks,
    addTodayTask,
    updateTodayTask,
    removeTodayTask,
    setLoaded,
    setInitialLoading,
    clearTodayTasks,
} = tasksSlice.actions;

export default tasksSlice.reducer;
